<!-- Custom Fields Section -->
<div *ngIf="isLoadingCustomFields$ | async" class="loading-container w-full mt-3">
  <mat-spinner diameter="32"></mat-spinner>
</div>
<ng-container *ngIf="(isLoadingCustomFields$ | async) === false">
  <ng-container *ngIf="displayFields$ | async as displayFields">
    <div *ngIf="displayFields && displayFields.length > 0" class="w-full mt-3">
      <div class="mb-3">
        <h3 class="text-lg font-medium text-primary">
          {{ 'Custom Fields' | transloco }}
        </h3>
        <p class="text-sm text-secondary">
          {{ 'Please fill in the required custom fields for this observation type' | transloco }}
        </p>
      </div>

      <!-- Render custom fields (includes synthetic/related fields) -->
      <div class="grid grid-cols-1 gap-4">
        <app-custom-field-renderer
          *ngFor="let field of displayFields; trackBy: trackByField"
          [field]="field"
          [form]="form"
          [disabled]="disabled"
        >
        </app-custom-field-renderer>
      </div>
    </div>
  </ng-container>
</ng-container>
